import React, { useEffect, useState } from 'react';

import { IUser } from "./shared/interfaces";
import Login from './components/Login';
import { MatrixService } from "./services/matrixservice";
import { MatrixSettings } from "./models/matrixSettings";
import Reports from './components/Reports';
import { ScreenSpinner } from './components/shared/ScreenSpinner';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { TopNavigation } from './components/layout/TopNavigation';
import axios from 'axios';
import { theme } from './shared/Theme';

const matrixService = new MatrixService();
const matrixSettings = new MatrixSettings();

const userAPI = matrixSettings.awsUrl + "/get-report-user/?userId=";

const App: React.FC = () => {

  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState<IUser | null>(null);
  const [isReportUser, setIsReportUser] = useState(false);
  const [userReports, setUserReports] = useState<string[]>([]);

  const logOut = async () => {
    await matrixService.logoutOfMatrix();
    setAuthenticated(false);
    window.location.href = "./";
  }

  const getReportUser = async (user:IUser) => {

          const _axiosHeaders = await matrixService.getHeaders();
          
          const response = await axios
            .get(userAPI + user.email, {"headers": _axiosHeaders});

          if(response){
            setIsReportUser(user.organisationId === parseInt(response.data.OrganisationId))
            setUserReports(response.data.ReportTypes)
          }
  }
  
  if(!authenticated){ 
    matrixService.getCurrentUser().then( async (_user) => {
      
      if(_user){
        const _isServiceAdmin = _user.roles.includes("SERVICE_ADMIN");

        if(!_isServiceAdmin) {
          await getReportUser(_user);
        }
        else {
          setIsReportUser(true);
          setUserReports(["ALL"])
        }
        setCurrentUser(_user);
      }

      setLoading(false);
    });
  }
    
  useEffect(() => {
    if(currentUser && currentUser.id > 0) {
      setAuthenticated(true);
    }
    else
    {
      setLoading(true);
    }
  }, [currentUser]);

  return (
    <ThemeProvider theme={theme}>
    <div>
      {authenticated && <TopNavigation logout={logOut}/>}

      <div className="App tw-flex tw-flex-col tw-w-full tw-items-center tw-h-full tw-bg-gainsboro"
          style={{overflow: "auto", maxHeight: "100vh", minWidth: "100%"}}>

        {(authenticated  && isReportUser) &&
          <div className="tw-flow-root tw-w-full tw-overflow-hidden">
            <Reports reportTypes={userReports} />
          </div>
        }

        {(authenticated  && !isReportUser) &&
          <div className="tw-flow-root tw-w-full">
            <div className="tw-m-8 tw-text-center">
                <span>You do not have access to Matrix Booking Insight. Please contact one of your Matrix Booking administrators to gain access. Visit our <a href="https://app.matrixbooking.com/ui/#/help" target="_blank" rel="noreferrer" className="tw-text-blue tw-underline">Help</a> section for more information.</span>
            </div>
          </div>
        }

        {loading &&
          <ScreenSpinner/>
        }
        
        {!authenticated && !loading &&
          <div className="tw-w-3/4">
            <Login />
          </div>
        }

      </div>
    </div>
    </ThemeProvider>
  );
}

export default App;
